import FormGenerator from './FormGenerator.vue'
import * as FormFields from './form'

// 安装函数
const install = function(Vue) {
  if (install.installed) return
  install.installed = true
  
  // 注册表单生成器组件
  Vue.component(FormGenerator.name, FormGenerator)
  
  // 注册所有字段组件
  Object.values(FormFields).forEach(component => {
    if (component && component.name) {
      Vue.component(component.name, component)
    }
  })
}

// 自动安装
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  FormGenerator,
  ...FormFields
}

export { FormGenerator }
export * from './form' 